<template>
  <div class="absolute w-full" style="top: 72px; z-index: 10">
    <img
      class="w-screen object-cover"
      style="height: 280px"
      :src="
        state.content.bannerUrl || require('@/assets/bgs/default-address.png')
      "
      alt="banner"
    />
  </div>
  <div
    class="pb-16 text-whitebase mx-auto h-full relative"
    style="max-width: 1200px; z-index: 12; margin-top: 216px"
  >
    <UiImg
      class="
        w-16
        lg:w-20
        h-16
        lg:h-20
        rounded-full
        overflow-hidden
        border-2 border-whitebase
      "
      :src="state.content.logo || require('@/assets/icons/nftnologo.avif')"
    ></UiImg>
    <div class="flex justify-between mt-9">
      <EnsAddress
        class="text-xl font-bold"
        max-width="max-content"
        :address="state.content.name || state.content.voterAddress"
        :size="8"
      ></EnsAddress>
      <div class="flex gap-4 items-center">
        <LinkCell :daoInfo="state.content"></LinkCell>
        <div
          class="
            flex
            items-center
            justify-center
            py-2
            px-4
            rounded-lg
            border border-whitebase
            text-sm
            font-bold
            cursor-pointer
          "
          @click="$router.push('/settings/profile')"
          v-if="state.content.voterAddress == userInfo.address"
        >
          <span class="icon iconfont icon-bianji mr-2"></span>
          Edit Profile
        </div>
      </div>
    </div>
    <div class="mt-2 flex gap-10 items-center">
      <div
        v-if="state.content.voterAddress"
        class="text-white-070 flex items-center gap-1"
      >
        {{ formatAddress(state.content.voterAddress, 6) }}
        <i
          class="iconfont icon-fuzhi2-29 pl-2 cursor-pointer text-whitebase"
          @click="copyAddress(state.content.voterAddress)"
        ></i>
      </div>

      <div v-if="state.create_at" class="text-sm text-white-040 mb-2">
        Created at: {{ formatDate(state.create_at) }}
      </div>

      <div
        class="text-sm text-white-040 mb-2"
        v-if="state.content.lastActiveTime"
      >
        Last active
        {{ formatDateText(state.content.lastActiveTime * 1000) }}
      </div>
    </div>
    <div class="flex gap-10">
      <div class="mt-2 flex items-center" v-if="state.content.skills">
        <div class="mr-2">Skills:</div>
        <div class="flex gap-2">
          <div
            v-for="(skill, i) in state.content.skills"
            :key="i"
            class="text-xs py-1 px-2 rounded-lg bg-white-010 text-white-070"
          >
            {{ skill }}
          </div>
        </div>
      </div>
      <div class="mt-2 flex items-center" v-if="state.content.tag">
        <div class="mr-2">Tags:</div>
        <div class="flex gap-2">
          <div
            v-for="(tag, i) in state.content.tag"
            :key="i"
            class="text-xs py-1 px-2 rounded-lg bg-white-010 text-white-070"
          >
            {{ tag }}
          </div>
        </div>
      </div>
    </div>
    <div class="flex justify-between mt-2">
      <div>
        <div v-if="state.content.description">
          {{ state.content.description }}
        </div>
      </div>
      <div class="flex items-center gap-2">
        <tippy v-if="NNSName && NNSName != ENSName" :content="NNSName">
          <img
            @click="handleAddressClick(state.content.voterAddress)"
            src="@/assets/icons/nouns-domain.png"
            class="w-6 h-6 rounded-full cursor-pointer"
        /></tippy>
        <tippy v-if="ENSName" :content="ENSName">
          <img
            @click="handleAddressClick(state.content.voterAddress)"
            src="@/assets/icons/ens-domain.png"
            class="w-6 h-6 cursor-pointer rounded-full"
        /></tippy>
      </div>
    </div>
    <div
      class="
        flex flex-wrap
        justify-center
        gap-6
        pt-6
        mt-6
        border-t border-white-010
      "
    >
      <div>
        <!-- <button
          class="flex items-center m-0 mb-4"
          @click="() => $router.back()"
        >
          <i class="iconfont text-base icon-left mr-1"></i>
          <span>Back</span>
        </button> -->
        <div class="flex-1 max-w-343px md:max-w-792px">
          <div class="flex w-full relative mb-6">
            <div class="relative w-full h-full">
              <div class="">
                <div class="font-bold text-xl mb-2">Overview</div>
                <div
                  class="
                    flex
                    rounded-lg
                    bg-white-005
                    items-center
                    justify-center
                  "
                >
                  <div
                    class="flex flex-col items-center justify-center"
                    :style="`width: ${isDesktop ? 248 : 109}px; height: ${
                      isDesktop ? 86 : 44
                    }px`"
                  >
                    <div class="font-bold text-base md:text-xl">
                      <CountUp
                        :isLocale="true"
                        :value="state.content.daos?.length"
                      />
                    </div>
                    <div class="text-white-040 text-sm">Related DAOs</div>
                  </div>
                  <div
                    class="flex flex-col items-center justify-center"
                    :style="`width: ${isDesktop ? 248 : 109}px; height: ${
                      isDesktop ? 86 : 44
                    }px`"
                  >
                    <div class="font-bold text-base md:text-xl">
                      <CountUp
                        :isLocale="true"
                        :value="state.content?.proposals"
                      />
                    </div>
                    <div class="text-white-040 text-sm">Proposals</div>
                  </div>
                  <div
                    class="flex flex-col items-center justify-center"
                    :style="`width: ${isDesktop ? 248 : 109}px; height: ${
                      isDesktop ? 86 : 44
                    }px`"
                  >
                    <div class="font-bold text-base md:text-xl">
                      <CountUp
                        :isLocale="true"
                        :value="state.content?.proposalsCreated"
                      />
                    </div>

                    <div class="text-white-040 text-sm">Proposed</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="isDesktop">
            <div class="mb-4 font-bold text-base md:text-xl">DAOs</div>
            <div class="swiper-container">
              <div
                class="swiper-wrapper"
                :class="{ 'mb-10': state.content.daos?.length > 3 }"
              >
                <div
                  class="
                    swiper-slide
                    bg-white-030
                    relative
                    rounded
                    border
                    cursor-pointer
                    h-full
                  "
                  :class="{
                    ' border-whitebase': item === state.selectDao,
                    'border-white-010 hover:border-white-050':
                      item !== state.selectDao,
                  }"
                  @click="
                    () => {
                      state.selectDao = item;
                    }
                  "
                  v-for="(item, i) in state.content.daos"
                  :key="i"
                  style="width: 180px; height: 180px"
                >
                  <ContentItem :item="item" />
                </div>
              </div>
              <div class="swiper-pagination"></div>

              <div
                class="
                  cursor-pointer
                  h-10
                  w-10
                  rounded-full
                  flex
                  items-center
                  justify-center
                  absolute
                  top-1/3
                  left-2.5
                  z-top
                  text-white-040
                  prev
                "
                @click="slideFourToLeft"
                v-if="state.content.daos?.length > 4"
              >
                <span class="icon iconfont text-2xl">&#xe60d;</span>
              </div>
              <div
                class="
                  cursor-pointer
                  h-10
                  w-10
                  rounded-full
                  flex
                  items-center
                  justify-center
                  absolute
                  top-1/3
                  right-2.5
                  z-top
                  text-white-040
                  next
                "
                @click="slideFourToRight"
                v-if="state.content.daos?.length > 4"
              >
                <span class="icon iconfont text-2xl">&#xe60e;</span>
              </div>
            </div>
            <div
              v-if="!loading && state.content.daos?.length < 1"
              class="flex items-center justify-center"
            >
              <img
                src="@/assets/bgs/no_data.avif"
                alt="no daos data found"
                class="relative"
              />
              <div class="text-white-040 absolute">No Data</div>
            </div>

            <div v-if="state.content?.daos?.length > 0">
              <div class="mb-4 mt-8 font-bold text-xl">
                {{ state.selectDao.name }}
              </div>
              <IconTabs
                :selected-tab="state.updatedTab"
                :tabs="state.tabs"
                :lastActiveTime="state?.daoDetails?.lastActiveTime"
                @platform-change="handlePlatformChange"
                @tabChange="handleTabChange"
              />
              <div
                class="
                  flex
                  h-10
                  items-center
                  px-4
                  justify-between
                  bg-white-005
                  rounded-lg
                  mb-4
                "
              >
                <div class="text-sm">Voting Power</div>
                <div class="flex">
                  <div class="font-bold">
                    {{
                      state.daoDetails?.votingPower ||
                      state.daoDetails?.votingPower === 0
                        ? state.daoDetails?.votingPower?.toLocaleString()
                        : '-'
                    }}
                  </div>
                  <div
                    class="text-base ml-2 text-white-070 whitespace-nowrap"
                    v-if="
                      state.selectedTab === 'On-Chain' &&
                      state.daoDetails?.quorum &&
                      state.daoDetails?.votingPower
                    "
                  >
                    ({{
                      parseFloat(
                        Number(
                          (state.daoDetails?.votingPower /
                            state.daoDetails?.quorum) *
                            100,
                        ).toFixed(2),
                      )
                    }}% of quorum)
                  </div>
                </div>
              </div>
              <div
                class="flex space-x-6 pb-4 border-b border-white-010"
                :style="`max-width: ${isDesktop ? '792px' : '100%'}`"
              >
                <div
                  class="
                    bg-white-005
                    hover:bg-white-010
                    rounded-2xl
                    flex flex-col
                    justify-center
                    items-center
                    cursor-pointer
                  "
                  :style="`background:${
                    state.detailIndex === 0
                      ? 'linear-gradient(315deg, #FF5585 0%, #268CFF 100%)'
                      : 'rgba(255,255,255,0.05)'
                  };`"
                  @click="
                    () => {
                      state.detailIndex = 0;
                    }
                  "
                  style="width: 248px; height: 102px"
                >
                  <div class="font-bold">
                    {{ state.daoDetails?.proposalsVoted }}&nbsp;of&nbsp;{{
                      state.daoDetails?.total
                    }}&nbsp;({{
                      (
                        (state.daoDetails?.proposalsVoted /
                          state.daoDetails?.total) *
                        100
                      ).toFixed(2)
                    }}%)
                  </div>
                  <div class="text-white-040 text-sm">
                    Proposals Voted (Participation Rate)
                  </div>
                  <div class="flex gap-2">
                    <Voted
                      v-for="(vote, v) in state.daoDetails?.last5VotesStatus"
                      :key="v"
                      :is-off-chain="
                        state.selectedTab === 'Off-Chain' ? true : false
                      "
                      :is-voted="true"
                      :value="vote"
                    />
                  </div>
                </div>
                <div
                  class="
                    bg-white-005
                    hover:bg-white-010
                    rounded-2xl
                    flex flex-col
                    justify-center
                    items-center
                    cursor-pointer
                  "
                  :style="`background:${
                    state.detailIndex === 1
                      ? 'linear-gradient(315deg, #FF5585 0%, #268CFF 100%)'
                      : 'rgba(255,255,255,0.05)'
                  };`"
                  @click="
                    () => {
                      state.detailIndex = 1;
                    }
                  "
                  style="width: 248px; height: 102px"
                >
                  <div class="font-bold">
                    {{ state.daoDetails?.proposalsCreated }}
                  </div>
                  <div
                    v-if="
                      state.daoDetails?.proposalsCreatedStatus &&
                      state.selectedTab === 'On-Chain'
                    "
                    class="flex justify-start gap-4"
                  >
                    <div
                      class="flex gap-1 text-xs items-center"
                      v-if="
                        state.daoDetails?.proposalsCreatedStatus['inProgress']
                      "
                    >
                      <Voted :is-status="true" value="inProgress" />
                      {{
                        state.daoDetails?.proposalsCreatedStatus['inProgress']
                      }}
                    </div>
                    <div
                      class="flex gap-1 text-xs items-center"
                      v-if="state.daoDetails?.proposalsCreatedStatus['passed']"
                    >
                      <Voted :is-status="true" value="passed" />
                      {{ state.daoDetails?.proposalsCreatedStatus['passed'] }}
                    </div>
                    <div
                      class="flex gap-1 text-xs items-center"
                      v-if="state.daoDetails?.proposalsCreatedStatus['failed']"
                    >
                      <Voted :is-status="true" value="failed" />
                      {{ state.daoDetails?.proposalsCreatedStatus['failed'] }}
                    </div>
                  </div>
                  <div class="text-white-040 text-sm">Proposed</div>
                </div>
                <div
                  class="
                    bg-white-005
                    hover:bg-white-010
                    rounded-2xl
                    flex flex-col
                    justify-center
                    items-center
                    cursor-pointer
                  "
                  :style="`background:${
                    state.detailIndex === 2
                      ? 'linear-gradient(315deg, #FF5585 0%, #268CFF 100%)'
                      : 'rgba(255,255,255,0.05)'
                  };`"
                  @click="
                    () => {
                      state.detailIndex = 2;
                    }
                  "
                  style="width: 248px; height: 102px"
                >
                  <div
                    v-if="
                      state.daoDetails?.delegationCount ||
                      state.daoDetails?.delegationCount === 0
                    "
                  >
                    <div class="text-whitebase text-center whitespace-nowrap">
                      Delegated by
                      <span class="font-bold">
                        {{ state.daoDetails?.delegationCount }}
                      </span>
                      accounts
                    </div>
                    <div
                      class="text-white-070 text-center justify-between text-sm"
                    >
                      {{
                        parseFloat(
                          Number(
                            state.daoDetails?.delegationVotingPower,
                          ).toFixed(0),
                        )?.toLocaleString()
                      }}&nbsp;(Voting Power)
                    </div>
                  </div>
                  <div v-else>-</div>
                  <div class="text-sm text-white-040">Delegations</div>
                </div>
              </div>
              <VotePie
                @updatedSelected="handleSelectedChoicesUpdate"
                :selected="selectedChoices"
                :data="state.daoDetails?.votesStats"
                v-if="
                  state.daoDetails?.votesStats?.length > 0 &&
                  state.detailIndex === 0
                "
              />

              <div v-if="state.detailIndex === 2">
                <div
                  class="flex rounded items-center bg-pass-topbg h-12 px-4"
                  :style="`max-width: ${isDesktop ? '792px' : '100%'}`"
                >
                  <div style="width: 30%">Delegator</div>
                  <div style="width: 25%">DAO</div>
                  <div style="width: 25%">Date</div>
                  <div style="width: 20%" class="text-right">Voting Power</div>
                </div>
              </div>
              <div
                class="data-container"
                :style="`max-width: ${isDesktop ? '792px' : '100%'}`"
                ref="container"
                @scroll="checkScroll"
              >
                <div
                  v-if="
                    !loadingVoted && !loadingDelegations && !loadingProposed
                  "
                >
                  <div v-for="(item, i) in displayedItemsArray" :key="i">
                    <div
                      v-if="
                        (state.detailIndex === 0 &&
                          selectedChoices.includes(item.choice)) ||
                        state.detailIndex === 1
                      "
                    >
                      <div v-if="state.detailIndex !== 2">
                        <div
                          class="px-6 py-4 border-b border-white-010"
                          style="height: 111px"
                        >
                          <div class="flex justify-between text-sm">
                            <div class="flex items-center">
                              <UiImg
                                class="
                                  w-5
                                  lg:w-16
                                  h-5
                                  lg:h-16
                                  rounded-full
                                  overflow-hidden
                                "
                                :src="
                                  state.content.logo ||
                                  require('@/assets/icons/nftnologo.avif')
                                "
                              ></UiImg>
                              <div class="flex flex-col ml-6">
                                <div
                                  class="line-clamp-1 whitespace-nowrap mb-2"
                                  style="max-width: 460px"
                                >
                                  {{
                                    state.detailIndex === 0
                                      ? 'Voted "' + item.choice + '"'
                                      : 'Create'
                                  }}
                                </div>
                                <div class="flex items-center">
                                  <div
                                    v-if="item.category"
                                    class="
                                      text-xs
                                      uppercase
                                      rounded
                                      px-2
                                      py-1
                                      bg-white-010
                                      whitespace-nowrap
                                    "
                                  >
                                    {{ item.category }}
                                  </div>
                                  <div
                                    class="
                                      overflow-ellipsis
                                      line-clamp-1
                                      ml-2
                                      cursor-pointer
                                    "
                                    style="max-width: 300px"
                                    @click="
                                      () => {
                                        $router.push(
                                          `/proposal/details/${item.id}`,
                                        );
                                      }
                                    "
                                  >
                                    {{ item.title }}
                                  </div>

                                  <div
                                    v-if="item.isCore"
                                    class="
                                      text-xs
                                      px-2
                                      ml-2
                                      h-5
                                      whitespace-nowrap
                                      flex
                                      items-center
                                    "
                                    style="
                                      width: 43px;
                                      background: rgba(255, 85, 133, 0.1);
                                      border-radius: 8px;
                                      border: 1px solid #ff5585;

                                      color: #ff5585;
                                    "
                                  >
                                    Core
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="flex flex-col justify-center items-end">
                              <div
                                class="
                                  h-6
                                  w-max
                                  px-2
                                  flex
                                  items-center
                                  justify-center
                                  rounded
                                  font-bold
                                  capitalize
                                  mb-2
                                "
                                :style="
                                  item.state == 'active'
                                    ? ''
                                    : item.state == 'pending'
                                    ? ''
                                    : 'background:#FFFFFF1A;color:#FFFFFF66;'
                                "
                                :class="{
                                  'bg-inputActive':
                                    activeType.indexOf(
                                      item.state?.toLowerCase(),
                                    ) !== -1,

                                  'bg-success':
                                    item.state?.toLowerCase() == 'pending',
                                }"
                              >
                                {{ item.state?.toLowerCase() }}
                              </div>
                              <div>
                                {{ formattedDateFull(item.created * 1000) }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="state.detailIndex === 2"
                      class="px-4 rounded flex item-center"
                      :class="{ 'bg-white-002': i % 2 === 0 }"
                      style="height: 56px"
                    >
                      <div style="width: 30%" class="flex items-center">
                        <EnsAddress
                          class="text-base"
                          :address="item.delegator"
                          :size="6"
                        ></EnsAddress>
                      </div>
                      <div class="flex items-center" style="width: 25%">
                        <UiImg
                          :src="
                            item.daoLogo ||
                            require('@/assets/icons/nftnologo.avif')
                          "
                          class="mr-2 w-8 h-8 rounded-full"
                        ></UiImg>

                        {{ item.daoName }}
                      </div>
                      <div style="width: 25%" class="flex items-center">
                        {{ formattedDateFull(item.created * 1000) }}
                      </div>
                      <div
                        style="width: 20%"
                        class="text-right flex items-center justify-end"
                      >
                        {{ abbrv_num(item.power) }}
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="displayedItemsArray.length < 1"
                    class="flex items-center justify-center"
                  >
                    <img
                      src="@/assets/bgs/no_data.avif"
                      alt="no daos data found"
                      class="relative"
                    />
                    <div class="text-white-040 absolute">No Data</div>
                  </div>
                </div>
                <div v-else class="flex justify-center items-center">
                  <Spin></Spin>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div
          class="bg-white-005 rounded w-343px sm:w-384px"
          style="height: max-content; padding-bottom: 20px"
        >
          <div class="flex justify-between items-center">
            <div class="px-2 py-6 md:p-6 font-bold text-base flex">
              <tippy
                content="The DAO badge will record your various contributions to DAO on the chain and publish them via dynamic NFT, and will continuously upgrade your reputation score based on your contributions to DAO!"
                :arrow="false"
              >
                <span class="text-whitebase">DAO Badge</span>&nbsp;
                <i class="iconfont icon-Wiki text-whitebase" />
              </tippy>
            </div>
          </div>
          <div
            v-if="!state.isMintedStatusLoading && state.isMinted"
            class="flex justify-between badgeInfo"
          >
            <a class="badgeImageBox" target="_blank" :href="state.tokenAddress">
              <img
                v-if="state.rankScoreData.image"
                class="badgeImage"
                :src="state.rankScoreData.image"
              />
            </a>
            <div class="flex-1 badgeInfoData">
              <div class="badgeInfoDataItem flex justify-between borderBottom">
                <label class="badgeInfoDataLabel text-white-080">Scores:</label>
                <label class="badgeInfoDataValue text-whitebase font-bold">{{
                  Number(state.rankScoreData.score || 0).toFixed(2)
                }}</label>
              </div>
              <div class="badgeInfoDataItem flex justify-between">
                <label class="badgeInfoDataLabel text-white-080">Rank:</label>
                <label class="badgeInfoDataValue text-whitebase font-bold"
                  >{{ fmoney(state.rankScoreData.rank, 0) }} ({{
                    (Number(state.rankScoreData.rankRatio || 0) * 100).toFixed(
                      2,
                    )
                  }}%)</label
                >
              </div>
            </div>
          </div>
          <div
            v-if="!state.isMintedStatusLoading && !state.isMinted"
            class="notMint w-full flex flex-col justify-center items-center"
          >
            <p
              v-if="userInfo.address === state.currentAddress"
              class="notMintedDesc"
            >
              More than a badge <br />
              Mint and unlock your on-chain DAO reputation
            </p>
            <p
              v-if="userInfo.address !== state.currentAddress"
              class="notMintedDesc"
            >
              This user has not yet minted their [DAO Badge]
            </p>
            <br />
            <router-link
              v-if="
                !state.isMinted &&
                !state.mintStateLoading &&
                userInfo.address === state.currentAddress
              "
              to="/mintBadge"
              class="active-button"
              style="
                min-width: 104px;
                padding: 0 10px;
                height: 40px;
                font-size: 16px;
              "
            >
              Mint Now
            </router-link>
          </div>
          <Spin v-if="state.isMintedStatusLoading"></Spin>
        </div>
        <br />
        <div
          class="bg-white-005 rounded w-343px sm:w-384px"
          style="height: max-content"
        >
          <div
            class="flex justify-between items-center border-b border-white-010"
          >
            <div class="px-2 py-6 md:p-6 font-bold text-base flex">
              Balance:
              <div
                class="ml-4"
                style="
                  background: linear-gradient(315deg, #ff5585 0%, #268cff 100%);
                  -webkit-background-clip: text;
                  -webkit-text-fill-color: transparent;
                "
              >
                <span v-if="state.currency == 1"
                  ><tippy content="ETH" :arrow="false">
                    <i
                      class="iconfont icon-ETH2-24"
                      style="font-size: inherit"
                    ></i> </tippy
                  >{{ (state.totalFtETH + state.totalNftETH).toFixed(3) }}</span
                >
                <span v-else>
                  $
                  {{ (state.totalFtUSD + state.totalNftUSD).toFixed(2) }}
                </span>
              </div>
            </div>
            <CustomDropDown
              @change="handleCurrencyChange"
              :options="currencySelect"
              :selectedIndex="state.currency"
            />
          </div>
          <div
            class="px-2 py-6 md:p-6 font-bold text-xs border-b border-white-010"
          >
            <div class="flex justify-between text-sm">
              <div class="text-white-070">
                FT Asset ({{
                  isNaN(
                    (
                      (state.currency === 0
                        ? state.totalFtUSD /
                          (state.totalFtUSD + state.totalNftUSD)
                        : state.totalFtETH /
                          (state.totalFtETH + state.totalNftETH)) * 100
                    ).toFixed(1),
                  )
                    ? 0
                    : (
                        (state.currency === 0
                          ? state.totalFtUSD /
                            (state.totalFtUSD + state.totalNftUSD)
                          : state.totalFtETH /
                            (state.totalFtETH + state.totalNftETH)) * 100
                      ).toFixed(1)
                }}%)
              </div>
              <div class="font-bold">
                <span v-if="state.currency == 1"
                  ><tippy content="ETH" :arrow="false">
                    <i
                      class="iconfont icon-ETH2-24"
                      style="font-size: inherit"
                    ></i> </tippy
                  >{{ state.totalFtETH.toFixed(3) }}</span
                >
                <span v-else>
                  $
                  {{ state.totalFtUSD.toFixed(2) }}
                </span>
              </div>
            </div>
            <div
              ref="ftContainer"
              @scroll="checkFtScroll"
              style="max-height: 336px; overflow-y: auto"
            >
              <div
                v-for="(item, i) in displayedFtArray"
                :key="i"
                @click="handleClick(item.link)"
                class="
                  h-14
                  flex
                  items-center
                  justify-between
                  cursor-pointer
                  hover:bg-white-010
                  rounded-lg
                "
              >
                <div class="flex items-center">
                  <UiImg
                    class="w-10 h-10 rounded-full"
                    :src="item.logo || require('@/assets/icons/nftnologo.avif')"
                  ></UiImg>
                  <div class="ml-2">
                    <div class="font-bold">{{ item.symbol }}</div>
                    <div><ChainCell :chain="item.chain"></ChainCell>1</div>
                  </div>
                </div>
                <div>
                  <div class="text-right">
                    <span v-if="state.currency == 1"
                      ><tippy content="ETH" :arrow="false">
                        <i
                          class="iconfont icon-ETH2-24"
                          style="font-size: inherit"
                        ></i> </tippy
                      >{{ abbrv_num(item.ethValue, 3) }}</span
                    >
                    <span v-else>
                      $
                      {{ abbrv_num(item.usdValue) }}
                    </span>
                  </div>
                  <div class="text-right">
                    {{
                      localeNumber(
                        Number.isInteger(item.amount)
                          ? item.amount.toFixed(0)
                          : item.amount.toFixed(2),
                        Number.isInteger(item.amount) ? 0 : 2,
                      )
                    }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="px-2 py-6 md:p-6 font-bold text-xs">
            <div class="flex justify-between text-sm">
              <div class="text-white-070">
                NFT Asset ({{
                  isNaN(
                    (
                      (state.currency === 0
                        ? state.totalNftUSD /
                          (state.totalFtUSD + state.totalNftUSD)
                        : state.totalNftETH /
                          (state.totalFtETH + state.totalNftETH)) * 100
                    ).toFixed(1),
                  )
                    ? 0
                    : (
                        (state.currency === 0
                          ? state.totalNftUSD /
                            (state.totalFtUSD + state.totalNftUSD)
                          : state.totalNftETH /
                            (state.totalFtETH + state.totalNftETH)) * 100
                      ).toFixed(1)
                }}%)
              </div>
              <div class="font-bold">
                <span v-if="state.currency == 1"
                  ><tippy content="ETH" :arrow="false">
                    <i
                      class="iconfont icon-ETH2-24"
                      style="font-size: inherit"
                    ></i> </tippy
                  >{{ state.totalNftETH.toFixed(3) }}</span
                >
                <span v-else>
                  $
                  {{ state.totalNftUSD.toFixed(2) }}
                </span>
              </div>
            </div>
            <div
              ref="nftContainer"
              @scroll="checkNftScroll"
              style="max-height: 336px; overflow-y: auto"
            >
              <div
                v-for="(item, i) in displayedNftArray"
                :key="i"
                @click="handleClick(item.link)"
                class="
                  h-14
                  flex
                  items-center
                  justify-between
                  cursor-pointer
                  hover:bg-white-010
                  rounded-lg
                "
              >
                <div class="flex items-center">
                  <UiImg
                    class="w-10 h-10 rounded-lg"
                    :src="item.logo || require('@/assets/icons/nftnologo.avif')"
                  ></UiImg>
                  <div class="ml-2">
                    <div
                      class="font-bold overflow-ellipsis line-clamp-1"
                      style="max-width: 180px"
                    >
                      {{ item.name }}
                    </div>
                    <div><ChainCell :chain="item.chain"></ChainCell></div>
                  </div>
                </div>
                <div>
                  <div class="text-right">
                    <span v-if="state.currency == 1"
                      ><tippy content="ETH" :arrow="false">
                        <i
                          class="iconfont icon-ETH2-24"
                          style="font-size: inherit"
                        ></i> </tippy
                      >{{ abbrv_num(item.ethValue, 3) }}</span
                    >
                    <span v-else>
                      $
                      {{ abbrv_num(item.usdValue) }}
                    </span>
                  </div>
                  <div class="text-right">
                    {{
                      localeNumber(
                        Number.isInteger(item.amount)
                          ? item.amount.toFixed(0)
                          : item.amount.toFixed(2),
                        Number.isInteger(item.amount) ? 0 : 2,
                      )
                    }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="bg-white-005 rounded mt-6 px-2 py-6 md:p-6 w-343px md:w-384px"
          style="height: max-content"
          v-if="state.poaps.length > 0"
        >
          <div class="font-bold text-base md:text-xl flex">
            POAPs
            <div class="font-normal text-sm text-white-040 ml-2">
              ({{ state.poaps.length }} in total)
            </div>
          </div>
          <div
            class="grid grid-cols-5 space-y-6"
            style="max-height: 360px; overflow-y: auto"
            ref="poapContainer"
            @scroll="checkPoapScroll"
          >
            <tippy
              v-for="(item, i) in displayedPoapArray"
              :key="i"
              :content="item.event.name"
              :arrow="false"
            >
              <a
                :href="'https://poap.gallery/event/' + item.event.id"
                target="_blank"
              >
                <img
                  :src="
                    item.event.image_url ||
                    require('@/assets/icons/nftnologo.avif')
                  "
                  :alt="item.event.name"
                  class="w-12 h-12 rounded-full cursor-pointer"
                  :class="{ 'mt-6': i === 0 }"
              /></a>
            </tippy>
          </div>
        </div>
      </div>
      <div v-if="!isDesktop">
        <div class="w-343px md:w-792px">
          <div class="mb-4 font-bold text-xl">DAOs</div>
          <div class="swiper-container">
            <div
              class="swiper-wrapper"
              :class="{ 'mb-10': state.content.daos?.length > 3 }"
            >
              <div
                class="
                  swiper-slide
                  bg-white-030
                  relative
                  rounded
                  border
                  cursor-pointer
                "
                :class="{
                  ' border-whitebase': item === state.selectDao,
                  'border-white-010 hover:border-white-050':
                    item !== state.selectDao,
                }"
                @click="
                  () => {
                    state.selectDao = item;
                  }
                "
                v-for="(item, i) in state.content.daos"
                :key="i"
                :style="`width: ${isDesktop ? 180 : 167}px; height: ${
                  isDesktop ? 180 : 167
                }px`"
              >
                <div
                  class="absolute inset-0 overflow-hidden bg-white z-0 rounded"
                >
                  <img
                    class="w-full h-full object-cover"
                    :src="item.logo || require('@/assets/icons/nftnologo.avif')"
                    alt=""
                  />

                  <div
                    class="
                      bg-background-70
                      backdrop-filter backdrop-blur-lg
                      w-full
                      h-full
                      absolute
                      top-0
                      left-0
                    "
                  ></div>
                </div>
                <div
                  class="
                    flex flex-col
                    h-full
                    relative
                    z-10
                    text-center
                    p-6
                    rounded
                  "
                >
                  <div
                    class="
                      flex flex-col
                      items-center
                      justify-center
                      w-full
                      h-full
                      rounded
                    "
                  >
                    <UiImg
                      class="w-16 h-16 rounded-full overflow-hidden mb-4"
                      :src="
                        item.logo || require('@/assets/icons/nftnologo.avif')
                      "
                    ></UiImg>
                    <div>
                      {{ item.name }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="swiper-pagination"></div>

            <div
              class="
                cursor-pointer
                h-10
                w-10
                rounded-full
                flex
                items-center
                justify-center
                absolute
                top-1/3
                left-2.5
                z-top
                text-white-040
                prev
              "
              @click="slideFourToLeft"
              v-if="isDesktop && state.content.daos?.length > 4"
            >
              <span class="icon iconfont text-2xl">&#xe60d;</span>
            </div>
            <div
              class="
                cursor-pointer
                h-10
                w-10
                rounded-full
                flex
                items-center
                justify-center
                absolute
                top-1/3
                right-2.5
                z-top
                text-white-040
                next
              "
              @click="slideFourToRight"
              v-if="isDesktop && state.content.daos?.length > 4"
            >
              <span class="icon iconfont text-2xl">&#xe60e;</span>
            </div>
          </div>

          <div
            v-if="!loading && state.content.daos?.length < 1"
            class="flex items-center justify-center"
          >
            <img
              src="@/assets/bgs/no_data.avif"
              alt="no daos data found"
              class="relative"
            />
            <div class="text-white-040 absolute">No Data</div>
          </div>

          <div v-if="state.content?.daos?.length > 0">
            <div class="mb-4 mt-8 font-bold text-xl">
              {{ state.selectDao.name }}
            </div>
            <IconTabs
              :tabs="state.tabs"
              :lastActiveTime="state?.daoDetails?.lastActiveTime"
              @platform-change="handlePlatformChange"
              @tabChange="handleTabChange"
            />
            <div
              class="flex justify-between pb-4 border-b border-white-010"
              :style="`max-width: ${isDesktop ? '792px' : '100%'}`"
            >
              <div
                class="
                  bg-white-005
                  hover:bg-white-010
                  rounded-lg
                  flex flex-col
                  justify-center
                  items-center
                  cursor-pointer
                  px-2
                  py-2
                "
                :class="{
                  'border-b-4 border-inputActive': state.detailIndex === 0,
                }"
                @click="
                  () => {
                    state.detailIndex = 0;
                  }
                "
                :style="`width: ${isDesktop ? 248 : 108}px;`"
              >
                <div class="text-sm font-bold">
                  {{ state.daoDetails?.proposalsVoted }}&nbsp;of&nbsp;{{
                    state.daoDetails?.total
                  }}&nbsp;({{
                    (
                      (state.daoDetails?.proposalsVoted /
                        state.daoDetails?.total) *
                      100
                    ).toFixed(2)
                  }}%)
                </div>
                <div class="flex gap-2">
                  <Voted
                    v-for="(vote, v) in state.daoDetails?.last5VotesStatus"
                    :key="v"
                    :is-off-chain="
                      state.selectedTab === 'Off-Chain' ? true : false
                    "
                    :is-voted="true"
                    :value="vote"
                  />
                </div>
                <div class="text-white-040 text-xs">
                  Proposals Voted (Participation Rate)
                </div>
              </div>
              <div
                class="
                  bg-white-005
                  hover:bg-white-010
                  rounded-lg
                  flex flex-col
                  justify-center
                  items-center
                  cursor-pointer
                  px-2
                  py-2
                "
                :class="{
                  'border-b-4 border-inputActive': state.detailIndex === 1,
                }"
                @click="
                  () => {
                    state.detailIndex = 1;
                  }
                "
                :style="`width: ${isDesktop ? 248 : 108}px; `"
              >
                <div class="text-sm font-bold">
                  {{ state.daoDetails?.proposalsCreated }}
                </div>
                <div
                  v-if="
                    state.daoDetails?.proposalsCreatedStatus &&
                    state.selectedTab === 'On-Chain'
                  "
                  class="flex justify-start gap-4 text-xs"
                >
                  <div
                    class="flex gap-1 text-xs items-center"
                    v-if="
                      state.daoDetails?.proposalsCreatedStatus['inProgress']
                    "
                  >
                    <Voted :is-status="true" value="inProgress" />
                    {{ state.daoDetails?.proposalsCreatedStatus['inProgress'] }}
                  </div>
                  <div
                    class="flex gap-1 text-xs items-center"
                    v-if="state.daoDetails?.proposalsCreatedStatus['passed']"
                  >
                    <Voted :is-status="true" value="passed" />
                    {{ state.daoDetails?.proposalsCreatedStatus['passed'] }}
                  </div>
                  <div
                    class="flex gap-1 text-xs items-center"
                    v-if="state.daoDetails?.proposalsCreatedStatus['failed']"
                  >
                    <Voted :is-status="true" value="failed" />
                    {{ state.daoDetails?.proposalsCreatedStatus['failed'] }}
                  </div>
                </div>
                <div class="text-white-040 text-xs">Proposed</div>
              </div>
              <div
                class="
                  bg-white-005
                  hover:bg-white-010
                  rounded-lg
                  flex flex-col
                  justify-center
                  items-center
                  cursor-pointer
                  px-2
                  py-2
                "
                :class="{
                  'border-b-4 border-inputActive': state.detailIndex === 2,
                }"
                @click="
                  () => {
                    state.detailIndex = 2;
                  }
                "
                :style="`width: ${isDesktop ? 248 : 108}px; `"
              >
                <div
                  v-if="
                    state.daoDetails?.delegationCount ||
                    state.daoDetails?.delegationCount === 0
                  "
                >
                  <div class="text-whitebase text-sm text-center">
                    Delegated by
                    <span class="font-bold">
                      {{ state.daoDetails?.delegationCount }}
                    </span>
                    accounts
                  </div>
                  <div
                    class="text-white-070 text-center justify-between text-xs"
                  >
                    {{
                      parseFloat(
                        Number(state.daoDetails?.delegationVotingPower).toFixed(
                          0,
                        ),
                      ).toLocaleString()
                    }}&nbsp;(Voting Power)
                  </div>
                </div>
                <div v-else>-</div>
                <div class="text-xs text-white-040">Delegations</div>
              </div>
            </div>
            <VotePie
              @updatedSelected="handleSelectedChoicesUpdate"
              :selected="selectedChoices"
              :data="state.daoDetails?.votesStats"
              v-if="
                state.daoDetails?.votesStats?.length > 0 &&
                state.detailIndex === 0
              "
            />
            <div
              class="data-container"
              :style="`max-width: ${isDesktop ? '792px' : 'auto'}`"
              ref="container"
              @scroll="checkScroll"
            >
              <div
                v-if="!loadingVoted && !loadingDelegations && !loadingProposed"
              >
                <div class="overflow-x-auto">
                  <div
                    v-if="state.detailIndex === 2"
                    class="text-sm"
                    style="width: 600px"
                  >
                    <div
                      class="
                        flex
                        rounded
                        text-white-070
                        items-center
                        bg-pass-topbg
                        h-12
                        px-4
                      "
                    >
                      <div style="width: 30%">Delegator</div>
                      <div style="width: 25%">DAO</div>
                      <div style="width: 25%">Date</div>
                      <div style="width: 20%" class="text-right">
                        Voting Power
                      </div>
                    </div>

                    <div v-for="(item, i) in displayedItemsArray" :key="i">
                      <div
                        class="px-4 rounded flex item-center"
                        :class="{ 'bg-white-002': i % 2 === 0 }"
                        style="height: 56px"
                      >
                        <div style="width: 30%" class="flex items-center">
                          <EnsAddress
                            :address="item.delegator"
                            :size="6"
                          ></EnsAddress>
                        </div>
                        <div class="flex items-center" style="width: 25%">
                          <UiImg
                            :src="
                              item.daoLogo ||
                              require('@/assets/icons/nftnologo.avif')
                            "
                            class="mr-2 w-8 h-8 rounded-full"
                          ></UiImg>

                          {{ item.daoName }}
                        </div>
                        <div style="width: 25%" class="flex items-center">
                          {{ formattedDateFull(item.created * 1000) }}
                        </div>
                        <div
                          style="width: 20%"
                          class="text-right flex items-center justify-end"
                        >
                          {{ abbrv_num(item.power) }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-for="(item, i) in displayedItemsArray"
                  :key="i"
                  class="overflow-x-auto"
                >
                  <div
                    v-if="
                      (state.detailIndex === 0 &&
                        selectedChoices.includes(item.choice)) ||
                      state.detailIndex === 1
                    "
                  >
                    <div v-if="state.detailIndex !== 2">
                      <div
                        class="px-2 lg:px-6 py-4 border-b border-white-010"
                        style="height: 210px"
                      >
                        <div class="flex flex-wrap justify-between text-sm">
                          <div class="flex items-center">
                            <div>
                              <UiImg
                                class="w-16 h-16 rounded-full overflow-hidden"
                                :src="
                                  state.content.logo ||
                                  require('@/assets/icons/nftnologo.avif')
                                "
                              ></UiImg>
                              <div
                                class="
                                  flex flex-col
                                  ml-0
                                  lg:ml-6
                                  overflow-hidden
                                "
                              >
                                <div
                                  class="
                                    text-white-040 text-sm
                                    lg:text-base
                                    whitespace-nowrap
                                    mb-2
                                    w-80
                                  "
                                >
                                  {{
                                    state.detailIndex === 0
                                      ? 'Voted "' + item.choice + '"'
                                      : 'Create'
                                  }}
                                </div>
                                <div class="flex items-center">
                                  <div
                                    v-if="item.category"
                                    class="
                                      text-xs
                                      uppercase
                                      rounded
                                      px-2
                                      py-1
                                      bg-white-010
                                      whitespace-nowrap
                                    "
                                  >
                                    {{ item.category }}
                                  </div>
                                  <div
                                    class="
                                      overflow-ellipsis
                                      line-clamp-1
                                      ml-2
                                      cursor-pointer
                                      text-sm
                                      lg:text-base
                                    "
                                    style="max-width: 300px"
                                    @click="
                                      () => {
                                        $router.push(
                                          `/proposal/details/${item.id}`,
                                        );
                                      }
                                    "
                                  >
                                    {{ item.title }}
                                  </div>

                                  <div
                                    v-if="item.isCore"
                                    class="
                                      text-xs
                                      px-2
                                      ml-2
                                      h-5
                                      whitespace-nowrap
                                      flex
                                      items-center
                                    "
                                    style="
                                      width: 43px;
                                      background: rgba(255, 85, 133, 0.1);
                                      border-radius: 8px;
                                      color: #ff5585;
                                      border: 1px solid #ff5585;
                                    "
                                  >
                                    Core
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            class="
                              mt-2
                              lg:mt-0
                              flex flex-col-reverse
                              lg:flex-col lg:justify-center lg:items-end
                              gap-2
                              lg:gap-0
                            "
                          >
                            <div
                              class="
                                h-6
                                w-max
                                px-2
                                flex
                                items-center
                                justify-center
                                rounded
                                font-bold
                                capitalize
                                mb-2
                              "
                              :style="
                                item.state == 'active'
                                  ? ''
                                  : item.state == 'pending'
                                  ? ''
                                  : 'background:#FFFFFF1A;color:#FFFFFF66;'
                              "
                              :class="{
                                'bg-inputActive':
                                  activeType.indexOf(
                                    item.state?.toLowerCase(),
                                  ) !== -1,

                                'bg-inputActive-70':
                                  item.state?.toLowerCase() == 'pending',
                              }"
                            >
                              {{ item.state?.toLowerCase() }}
                            </div>
                            <div class="text-sm lg:text-base text-white-040">
                              {{ formattedDateFull(item.created * 1000) }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="displayedItemsArray.length < 1"
                  class="flex items-center justify-center"
                >
                  <img
                    src="@/assets/bgs/no_data.avif"
                    alt="no daos data found"
                    class="relative"
                  />
                  <div class="text-white-040 absolute">No Data</div>
                </div>
              </div>
              <div v-else class="flex justify-center items-center">
                <Spin></Spin>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
// import { Swiper, SwiperSlide } from 'swiper/vue';

// Import Swiper styles
import {
  abbrv_num,
  formatAddress,
  formatDate,
  formatDateText,
  formattedDateFull,
  formatVal,
  localeNumber,
} from '@/utils';
// import required modules
import Swiper, { Navigation, Pagination } from 'swiper';
import 'swiper/swiper-bundle.css';
import { useDesktop, useReq } from '@/hooks';
import { fmoney } from '@/utils/index';
import {
  getAddressDetails,
  getAddressFt,
  getAddressNft,
  getDaoDetails,
  getDaoVoted,
  getDaoProposed,
  getDaoDelegation,
  getGovPlatform,
  getProfile,
  getDynamicNftData,
  getRankScoreData,
  getMintedPersonalData,
  getMintedTokenId,
} from '@/api/dao';
import CustomDropDown from '@/components/Inputs/CustomDropDown.vue';

import ContentItem from './components/ContentItem.vue';
import { computed, inject, onMounted, reactive, watch, ref } from 'vue';
import { useRoute } from 'vue-router';
import { useRouter } from 'vue-router';
import UiImg from '@/components/UiImg.vue';
import EnsAddress from '../Home/component/EnsAddress.vue';
import ChainCell from './components/ChainCell.vue';
import { getSuccessResultAsync, passHttp } from '@/utils/req';
import copy from 'copy-to-clipboard';
import { notify } from '@kyvg/vue3-notification';
import Spin from '@/components/Spin.vue';
import axios from 'axios';
import CountUp from '@/components/CountUp.vue';
import IconTabs from './components/IconTabs.vue';
import Voted from './components/Voted.vue';
import VotePie from './components/VotePie.vue';
import LinkCell from '@/components/LinkCell.vue';
import { useReqByBool, useReqPages, useUserInfo } from '@/hooks';
import { ethers, utils } from 'ethers';
const userInfo = useUserInfo();
const currencySelect = [
  {
    label: 'USD',
    value: 'usd',
  },
  { label: 'ETH', value: 'eth' },
];
const handleCurrencyChange = (currencyIndex) => {
  console.log('current currency', currencyIndex);
  state.currency = currencyIndex;
};
const activeType = ['active', 'succeeded', 'queued'];
Swiper.use([Navigation, Pagination]);
const container = ref(null);
const ftContainer = ref(null);
const nftContainer = ref(null);
const poapContainer = ref(null);
const props = defineProps({ content: Array });
const isDesktop = useDesktop();
const ENSName = ref(null);
const NNSName = ref(null);
const selectedChoices = ref([]);

const getRankScore = async (address) => {
  try {
    const res = await getRankScoreData({
      address,
    });
    state.rankScoreData = res;
  } catch (e) {
    notify({
      type: 'error',
      text: JSON.stringify(e),
    });
  }
};

const getTokenIdIfMinted = async (address) => {
  try {
    const data = await getMintedTokenId({ address });
    if (data) {
      state.isMinted = true;
      state.tokenAddress =
        'https://optimistic.etherscan.io/token/0xe31baa13df378338071106af5bb92de463bd6d89?a=' +
        data;
    } else {
      state.isMinted = false;
    }
    state.isMintedStatusLoading = false;
  } catch (e) {
    notify({
      type: 'error',
      text: JSON.stringify(e),
    });
  }
};

const getEnsName = async (address) => {
  try {
    ENSName.value = null;
    NNSName.value = null;
    const provider = new ethers.providers.JsonRpcProvider(
      `https://mainnet.infura.io/v3/${process.env.VUE_APP_INFURA_ID}`,
    );

    // NNSENSReverseResolver Contract Details
    const NNSENSReverseResolverAddress =
      '0x849f92178950f6254db5d16d1ba265e70521ac1b';
    const NNSENSReverseResolverABI = [
      'function resolve(address) view returns (string)',
    ];
    const resolverContract = new ethers.Contract(
      NNSENSReverseResolverAddress,
      NNSENSReverseResolverABI,
      provider,
    );

    // Attempt to resolve using NNSENSReverseResolver

    const nnsName = await resolverContract.resolve(address);
    if (nnsName) {
      NNSName.value = nnsName;
    }

    // Fallback to ENS if NNS fails
    let ensName = await provider.lookupAddress(address);
    if (ensName) {
      ENSName.value = ensName;
    } else {
      throw new Error('Invalid Ens Name');
    }
  } catch (error) {
    console.log(error);
  }
};

const address = computed(() => {
  return $route.params.address;
});

const state = reactive({
  swiper: null,
  sortValue: [0, -1, -1],
  results: [],
  viewStateList: false,
  content: [],
  ft: [],
  displayedFt: 10,
  displayedNft: 10,
  displayedPoap: 50,
  nft: [],
  tokenId: '',
  selectDao: null,
  daoDetails: null,
  detailIndex: 0,
  daoDetailsData: [],
  displayedItems: 20,
  totalFtUSD: 0,
  totalFtETH: 0,
  totalNftUSD: 0,
  totalNftETH: 0,
  poaps: [],
  create_at: null,
  lens: null,
  selectedTab: null,
  selectedPlatform: null,
  updatedTab: null,
  currency: 0,
  isMinted: false,
  isMintedStatusLoading: true,
  rankScoreData: {
    image: '',
    score: '',
    rank: '',
    rankRatio: '',
  },
});
// const isFtOverflowing = computed(() => {
//   if (!ftContainer.value) {
//     return false;
//   }
//   return ftContainer.value.scrollHeight > ftContainer.value.clientHeight;
// });
// const isNftOverflowing = computed(() => {
//   if (!nftContainer.value) {
//     return false;
//   }
//   return nftContainer.value.scrollHeight > nftContainer.value.clientHeight;
// });
function slideFourToLeft() {
  const index = state.swiper.activeIndex - 4;
  state.swiper.slideTo(index >= 0 ? index : 0);
}
const handlePlatformChange = (currentTab, tabName, platform) => {
  if (currentTab === tabName) state.selectedPlatform = platform;
};
const handleTabChange = (newTab, platform) => {
  state.selectedTab = newTab;
  state.selectedPlatform = platform;
};

const handleAddressClick = (address) => {
  window.open(`https://etherscan.io/address/${address}`);
};

const handleSelectedChoicesUpdate = (choice) => {
  if (selectedChoices.value.includes(choice)) {
    // Remove the choice
    let index = selectedChoices.value.indexOf(choice);
    selectedChoices.value.splice(index, 1);
  } else {
    // Add the choice
    selectedChoices.value.push(choice);
  }
  console.log('selected choices updated', selectedChoices.value);
};

watch(
  () => state.selectedPlatform,
  () => {
    if (state.selectedPlatform) {
      loadDaoDetails();
      loadDaoIndexData();
    }
  },
);

function slideFourToRight() {
  const index = state.swiper.activeIndex + 4;
  const lastIndex = state.swiper.slides.length - 1;
  state.swiper.slideTo(index <= lastIndex ? index : lastIndex);
}
const displayedItemsArray = computed(() => {
  return state.daoDetailsData
    .filter((item) =>
      state.detailIndex === 0
        ? selectedChoices.value.includes(item.choice)
        : true,
    )
    .slice(0, state.displayedItems);
});
const displayedFtArray = computed(() => {
  return state.ft.slice(0, state.displayedFt);
});
const displayedPoapArray = computed(() => {
  return state.poaps.slice(0, state.displayedPoap);
});
const displayedNftArray = computed(() => {
  return state.nft.slice(0, state.displayedNft);
});
const checkScroll = () => {
  const containerElement = container.value;
  if (
    containerElement.scrollTop + containerElement.clientHeight >=
    containerElement.scrollHeight
  ) {
    state.displayedItems += 10;
  }
};
const checkFtScroll = () => {
  const containerElement = ftContainer.value;

  if (
    containerElement.scrollTop + containerElement.clientHeight >=
    containerElement.scrollHeight
  ) {
    state.displayedFt += 6;
  }
};
const handleClick = (link) => {
  window.open(link);
};
const checkNftScroll = () => {
  const containerElement = nftContainer.value;
  if (
    containerElement.scrollTop + containerElement.clientHeight >=
    containerElement.scrollHeight
  ) {
    state.displayedNft += 6;
  }
};
const checkPoapScroll = () => {
  const containerElement = poapContainer.value;

  if (
    containerElement.scrollTop + containerElement.clientHeight >=
    containerElement.scrollHeight
  ) {
    state.displayedPoap += 10;
  }
};
const $router = useRouter();
const $route = useRoute();

const { loading, loadData } = useReq(async () => {
  state.content = await getAddressDetails(address.value);
  state.currentAddress = address.value;
  getEnsName(state.content.voterAddress);
  getRankScore(address.value);
  getTokenIdIfMinted(address.value);
  try {
    // axios
    //   .get(`https://api.debank.com/user/addr?addr=${address.value}`)
    //   .then((response) => {
    //     state.create_at = response.data.data.create_at * 1000;
    //   });
  } catch (error) {
    console.log(error);
  }
  axios
    .post('https://api.lens.dev/playground', {
      operationName: 'DefaultProfile',
      variables: {},
      query: `query DefaultProfile {\n  defaultProfile(\n    request: {ethereumAddress: "${address.value}"}\n  ) {\n    id\n    name\n    bio\n    isDefault\n    handle\n    picture {\n      ... on NftImage {\n        contractAddress\n        tokenId\n        uri\n        chainId\n        verified\n      }\n      ... on MediaSet {\n        original {\n          url\n          mimeType\n        }\n      }\n    }\n    coverPicture {\n      ... on NftImage {\n        contractAddress\n        tokenId\n        uri\n        chainId\n        verified\n      }\n      ... on MediaSet {\n        original {\n          url\n          mimeType\n        }\n      }\n    }\n  }\n}\n`,
    })
    .then((response) => {
      state.lens = response.data.data.defaultProfile;
    })
    .catch((error) => {
      console.error(error);
    });
});
const config = {
  headers: {
    'x-api-key': process.env.VUE_APP_POAP_API,
    accept: 'application/json',
  },
};
const { loading: loadingPoap, loadData: loadPoap } = useReq(async () => {
  try {
    axios
      .get(`https://api.poap.tech/actions/scan/${address.value}`, config)
      .then((response) => {
        state.poaps = response.data;
      });
  } catch (e) {
    console.log(e);
  }
});

const { loading: loadingVoted, loadData: loadVoteData } = useReq(async () => {
  state.daoDetailsData = await getDaoVoted(
    address.value,
    state.selectDao.id,
    state.selectedPlatform,
  );
});
const { loading: loadingProposed, loadData: loadProposedData } = useReq(
  async () => {
    state.daoDetailsData = await getDaoProposed(
      address.value,
      state.selectDao.id,
      state.selectedPlatform,
    );
  },
);
const { loading: loadingDelegations, loadData: loadDelegationData } = useReq(
  async () => {
    state.daoDetailsData = await getDaoDelegation(
      address.value,
      state.selectDao.id,
      state.selectedPlatform,
    );
  },
);
const getGovPlatformsAll = async () => {
  state.tabs = [];
  const res = await getGovPlatform(state.selectDao.id);
  state.onChainList = res.onChainPlatforms;
  state.offChainList = res.offChainPlatforms;
  if (state.onChainList?.length > 0)
    state.tabs = [
      ...state.tabs,
      { name: 'On-Chain', platforms: state.onChainList },
    ];
  if (state.offChainList?.length > 0)
    state.tabs = [
      ...state.tabs,
      { name: 'Off-Chain', platforms: state.offChainList },
    ];

  if ($route.query.chain) {
    const chainIndex = state.tabs.findIndex(
      (t) => t.name == $route.query.chain,
    );
    if (chainIndex !== -1) {
      state.updatedTab = $route.query.chain;
    } else {
      state.updatedTab = null;
    }
  }
};

const getDaoDetail = async () => {
  if (state.selectDao) {
    state.daoDetails = await getDaoDetails(
      address.value,
      state.selectDao.id,
      state.selectedPlatform,
    );
    console.log(state.daoDetails.votesStats, [
      ...new Set(state.daoDetails.votesStats.map((obj) => obj.choice)),
    ]);
    selectedChoices.value =
      [...new Set(state.daoDetails.votesStats.map((obj) => obj.choice))] ?? [];
  }
};

const { loading: loadingDaoDetails, loadData: loadDaoDetails } =
  useReq(getDaoDetail);

const { loading: loadingFt, loadData: loadFtData } = useReq(async () => {
  state.ft = await getAddressFt(address.value);
  state.totalFtUSD = 0;
  state.totalFtETH = 0;
  state.ft.forEach((ft) => {
    state.totalFtUSD += ft.usdValue;
    state.totalFtETH += ft.ethValue;
  });
});
const { loading: loadingNFT, loadData: loadNftData } = useReq(async () => {
  state.nft = await getAddressNft(address.value);
  state.totalNftUSD = 0;
  state.totalNftETH = 0;
  state.nft.forEach((nft) => {
    state.totalNftUSD += nft.usdValue;
    state.totalNftETH += nft.ethValue;
  });
});
const copyAddress = (address) => {
  if (copy(address)) {
    notify({
      text: 'Copy Successfully',
    });
  }
};
watch(
  () => state.content,
  () => {
    if (state.content.daos?.length > 0) {
      if (state.content.daos?.length > 1 && $route.query.dao) {
        if ($route.query.dao) {
          const selectDaoIndex = state.content.daos.findIndex(
            (d) => d.id == $route.query.dao,
          );
          if (selectDaoIndex !== -1) {
            state.selectDao = state.content.daos[selectDaoIndex];
            state.swiper.slideTo(selectDaoIndex);
          } else {
            state.selectDao = state.content.daos[0];
          }
        }
      } else {
        state.selectDao = state.content.daos[0];
      }
    }
  },
);
watch(
  () => state.detailIndex,
  () => {
    loadDaoIndexData();
  },
);
const loadAllData = () => {
  loadData();
  loadPoap();
  loadFtData();
  loadNftData();
};
const loadDaoIndexData = () => {
  if (state.detailIndex === 0) {
    loadVoteData();
  }
  if (state.detailIndex === 1) {
    loadProposedData();
  }
  if (state.detailIndex === 2) {
    loadDelegationData();
  }
};

watch(
  () => state.selectDao,
  () => {
    getGovPlatformsAll();
    loadDaoIndexData();
    getDaoDetail();
  },
);

watch(
  () => $route.params.address,
  () => {
    loadAllData();
  },
);

onMounted(() => {
  state.swiper = new Swiper('.swiper-container', {
    slidesPerView: 2,
    spaceBetween: 16,
    observeParents: true,
    observer: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      dynamicBullets: true,
      renderBullet: function (index, className) {
        return '<div class="' + className + '"></div>';
      },
    },
    breakpoints: {
      1024: {
        slidesPerView: 4,
        spaceBetween: 24,
      },
    },
  });
  loadAllData();
});
</script>
<style>
.swiper-pagination {
  margin-top: 20px;
}
.swiper-pagination-bullet {
  width: 15px !important;
  height: 4px !important;
  background: rgba(255, 255, 255, 0.6) !important;
  border-radius: 4px !important;
}
.swiper-pagination-bullet-active {
  color: #fff !important;
  width: 20px !important;
  height: 4px !important;
  background: #fff !important;
}

.swiper-button-prev,
.swiper-button-next {
  top: 90% !important;
  width: 10px !important;
  height: 10px !important;
  color: rgba(255, 255, 255, 0.4) !important;
}
.prev,
.next {
  transition: all 0.2s ease-in-out;
  background: rgba(18, 20, 22, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.1);
}
.prev:hover {
  transform: translateX(-6px);
  box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.4);
}
.next:hover {
  transform: translateX(6px);
  box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.4);
}
.data-container {
  height: 500px;
  overflow-y: auto;
  overflow-x: hidden;
}
.badgeInfoData {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  height: 96px;
}
.badgeInfo {
  gap: 16px;
  padding: 0 20px;
  box-sizing: border-box;
}
.badgeImageBox {
  display: block;
  width: 120px;
  height: 120px;
  border-radius: 8px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.1);
}
.badgeImage {
  width: 100%;
  height: 100%;
}
.badgeInfoDataItem {
  box-sizing: border-box;
  padding: 0;
  align-items: center;
  font-size: 12px;
  height: 48px;
}
.borderBottom {
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}
.badgeInfoDataLabel,
.badgeInfoDataValue {
  font-size: 12px;
}
.badgeInfoDataLabel {
  margin-left: 16px;
}
.badgeInfoDataValue {
  margin-right: 16px;
}
.notMintedDesc {
  text-align: center;
}
</style>
